import React, { useContext, useEffect, useState } from "react";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";
import estilo from "./styles/Usuarios.module.css";
import foto from "../img/user1.png";
import Contactos from "./Contactos";

function Usuarios({ dato, cantidad, numI, numF, setNumI, setNumF }) {
  const { usuario, url, click, setClick } = useContext(DataContext);

  const [cargando, setCargando] = useState(false);
  const [cambioBoton, setCambioBoton] = useState(false);
  const [listaContactos, setListaContactos] = useState([]);

  //carga
  useEffect(() => {
    setTimeout(() => {
      setCargando(true);
    }, 500);
  }, []);

  //verificar contactos
  useEffect(() => {
    const fetchContacto = async () => {
      const { data } = await supabase
        .from("usuarios_chat")
        .select()
        .eq("user_id", usuario.id);

      if (data.length > 0) {
        setListaContactos(
          data
            .map((e) => e.contactos)[0]
            .filter((e) => e.contacto_id === dato.user_id)
        );
      }
    };

    fetchContacto();
  }, [cambioBoton]);

  //agregar contacto
  async function agregarContacto() {
    //obtener contactos
    const { data: usuarioData, error } = await supabase
      .from("usuarios_chat")
      .select("contactos")
      .eq("user_id", usuario.id)
      .single();

    const nuevoContacto = usuarioData.contactos.concat({
      id: dato.id,
      correo: dato.correo,
      usuario: dato.nombre_usuario,
      contacto_id: dato.user_id,
      bloqueado: false,
    });

    //insertar datos al json
    if (nuevoContacto) {
      const { error } = await supabase
        .from("usuarios_chat")
        .update({ contactos: nuevoContacto })
        .eq("user_id", usuario.id);

      console.log(error);
    }

    // console.log("nuevoContacto", nuevoContacto);
    setCambioBoton(!cambioBoton);
    siguiente();
    setClick(!click);
  }

  //eliminar contacto
  async function eliminarContacto() {
    //obtener contactos
    const { data: usuarioData, error } = await supabase
      .from("usuarios_chat")
      .select("contactos")
      .eq("user_id", usuario.id)
      .single();

    //filtrar contactos y crear nuevo arreglo sin el contacto a eliminar
    const nuevosContactos = usuarioData.contactos.filter(
      (e) => e.contacto_id !== dato.user_id
    );
    console.log("nuevos", nuevosContactos);
    //actualizar campo contactos en la base de datos con el nuevo arreglo
    if (nuevosContactos) {
      const { error } = await supabase
        .from("usuarios_chat")
        .update({ contactos: nuevosContactos })
        .eq("user_id", usuario.id);

      if (error) {
        console.log(error);
      }

      eliminarContactoChat(dato.user_id);
    }
    setCambioBoton(!cambioBoton);
    siguiente();
    setClick(!click);
  }

  async function eliminarContactoChat(userId) {
    const { data: usuarioData, error } = await supabase
      .from("usuarios_chat")
      .select("contactos")
      .eq("user_id", userId)
      .single();

    if (usuarioData && usuarioData.contactos) {
      const nuevosContactos = usuarioData.contactos.filter(
        (e) => e.contacto_id !== usuario.id
      );

      if (nuevosContactos) {
        const { error } = await supabase
          .from("usuarios_chat")
          .update({ contactos: nuevosContactos })
          .eq("user_id", userId);

        if (error) {
          console.log(error);
        }
      }
    }
  }

  const [limite, setLimite] = useState(false);

  //pasar al siguiente
  function siguiente() {
    if (numF >= cantidad) {
      return setLimite(true);
    }
    setNumI(numI + 1);
    setNumF(numF + 1);
  }

  return (
    <div className={estilo.usuarios}>
      {cargando ? (
        limite ? (
          <div className={estilo.cargando}>
            <p>No hay más usuarios...</p>
          </div>
        ) : (
          <div className={estilo.informacion}>
            <div className={estilo.detalles}>
              <p>{dato.nombre_usuario}</p>
              <p>{dato.sexo}</p>
              <p>{dato.edad} Años</p>
            </div>

            <div className={estilo.foto}>
              <img
                src={url + dato.user_id}
                alt={dato.nombre_usuario}
                width="100px"
                height="100px"
              />
            </div>

            <div className={estilo.botones}>
              <button onClick={siguiente}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className={estilo.siguiente}
                >
                  <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"></path>
                </svg>
              </button>

              {listaContactos.length > 0 ? (
                <button onClick={eliminarContacto}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.contacto}
                  >
                    <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM8 17s1-3 4-3 4 3 4 3H8zm9.553-4.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"></path>
                  </svg>
                </button>
              ) : (
                <button onClick={agregarContacto}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.agregar}
                  >
                    <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414-6.706 6.706z"></path>
                  </svg>
                </button>
              )}
            </div>
          </div>
        )
      ) : (
        <div className={estilo.cargando}>
          <p>Cargando...</p>
        </div>
      )}
    </div>
  );
}

export default Usuarios;
